import Isotope from 'isotope-layout/dist/isotope.pkgd.min.js';

(function () {
    'use strict';

    function scholarshipFinder($filter, scholarshipsService) {

        var isoFilters = {},
            scholarshipNodes = $('.scholarship-item'),
            validScholarships,
            filterString = '[data-status*="True"]',
            id = document.querySelector('[data-node]').dataset.node;

        let iso;

        this.activeFilters = [];
        this.showingAll = false;

        scholarshipsService.init(id).then(resp => {
            this.filters = resp.filters;
            this.scholarships = resp.scholarships;
            this.prefilters = resp.prefilters;

            prefilter();

            iso = new Isotope(document.querySelector('.scholarships-row'), {
                itemSelector: '.scholarship-item',
                getSortData: {
                    name: el => $(el).find('h5').text()                    
                },
                sortBy: 'name'
            });

            this.reset();
        });
       

        // if the API returns a prefilter object, we need to remove all matching nodes from the DOM
        // nodes will have a data attribute matching the prefilter key, formatted data-word-word
        // the prefilter key is camel cased, so it needs to be converted to match the data attribute format
        const prefilter = () => {
            if (this.prefilters !== undefined) {
                Object.keys(this.prefilters).forEach(key => {
                    var dataLabel = 'data-' + key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

                    // can't iterate NodeList directly, but ...spread works fine
                    [...scholarshipNodes].forEach(s => {
                        if (s.getAttribute(dataLabel).indexOf(this.prefilters[key]) === -1) {
                            $(s).remove();
                        }
                    });
                });
            }
        }

        this.selectFilter = (field, option) => {

            var filter = "[data-" + field.safe + "*='" + option.value + "']";

            if (isoFilters[field.safe] === filter) {
                this.removeFilter(field, option);
            } else {

                setOption(field, option);
                applyFilter();
                refreshCounts();

                isoFilters[field.safe] = filter;
                isoFilters['status'] = this.showingAll ? '[class*="scholarship-item"]' : '[data-status="True"]';

                iso.arrange({ filter: concatValues(isoFilters), sortBy: 'name' });
            }
        }

        const concatValues = obj => {
            var value = '';
            for (let prop of Object.keys(obj)) {
                value += obj[prop];
            }

            return value;
        }

        const setOption = (field, option) => {
            if (option.active) {
                option.active = false;
            } else {
                field.options.forEach(v => v.active = false);
                option.active = true;
            }
        }

        this.removeFilter = field => {
            // update the ui
            delete isoFilters[field.safe];
            var option = $filter('filter')(field.options, { active: true });

            iso.arrange({ filter: concatValues(isoFilters), sortBy: 'name' });

            // update the filter model
            setOption(field, option);
            applyFilter();
            refreshCounts();
        }

        const applyFilter = () => {
            this.activeFilters = [];

            this.filters.forEach(f => {
                f.options.forEach(o => {
                    if (o.active)
                        this.activeFilters.push({ field: f.field.toLowerCase(), value: o.value });
                });
            });

            validScholarships = this.scholarships.filter(scholarship => {
                var isValid = true;

                if (!this.showingAll && scholarship.isOpen === '0')
                    return false;

                this.activeFilters.forEach(af => {
                    if (!isValid)
                        return;

                    var fieldValue = scholarship[af.field];

                    if (Object.prototype.toString.call(fieldValue) === '[object Array]') {
                        var found = false;
                        fieldValue.forEach(fv => found = found || fv == af.value);
                        isValid = isValid && found;
                    } else {
                        isValid = isValid && scholarship[af.field] == af.value;
                    }
                });
                return isValid;
            });
        };

        const refreshCounts = () => {
            this.filters.forEach(field => {
                field.options.forEach(o => {
                    var count = 0,
                        af = { field: field.field.toLowerCase(), value: o.value };

                    validScholarships.forEach(scholarship => {

                        var isValid, fieldValue = scholarship[af.field];

                        if (Object.prototype.toString.call(fieldValue) === '[object Array]') {
                            var found = false;
                            fieldValue.forEach(fv => found = found || fv == af.value);                            
                            isValid = found;
                        } else {
                            isValid = scholarship[af.field] == af.value;
                        }

                        if (isValid) {
                            count++;
                        }
                    });
                    o.count = count;
                });
            });
        };

        this.toggleAll = () =>{

            isoFilters['status'] = this.showingAll ? '[class*="scholarship-item"]' : '[data-status="True"]';
            iso.arrange({ filter: concatValues(isoFilters), sortBy: 'name' });

            applyFilter();
            refreshCounts();
        }

        this.reset = () => {

            isoFilters = {};
            iso.arrange({ filter: filterString });

            this.activeFilters = [];
            this.visibleFilters = [];

            validScholarships = this.scholarships;

            this.filters.forEach(f =>  {
                this.visibleFilters.push(false);
                f.options.forEach(o => o.active = false);
            });

            this.isOpen = false;
            this.showingAll = false;

            applyFilter();
            refreshCounts();
        }
    }

    angular.module('Uscapp').controller('ScholarshipFinderCtrl', ['$filter', 'scholarshipsService', scholarshipFinder]);

}());